import Input from "../../../components/Input"
import { Grid} from "@mui/material"

const Objective = ({ fieldValues, handleOnChange}) => {
    const fields = [
        {name:'objective', label:'Objective', type: 'textarea'}
    ]
    return <Grid container>
        {fields.map((field, index)=>{
            return <Grid item xs={12} p={3} key={index}>
                <Input name={field.name} label={field.label} value={fieldValues[field.name]} key={index} handleOnChange={handleOnChange} multiline={true}/>
             </Grid>
        })}
    </Grid>
}

export default Objective